import { useTranslation } from "react-i18next";
import { useSyncStore } from "../store/syncStore";
import { WifiOff, RefreshCw } from "./icons";

export default function OfflineIndicator() {
  const { t } = useTranslation("common");
  const {
    isOnline,
    isSyncing,
    pendingCount,
    lastSync,
    lastSyncAttemptOutcome,
  } = useSyncStore();

  if (isOnline && pendingCount === 0 && lastSync === null) {
    return null;
  }

  return (
    <div
      className="fixed top-[60px] left-0 right-0 z-40"
      data-testid="offline-indicator"
    >
      {!isOnline && (
        <div
          className="bg-yellow-500 text-white text-center py-2 px-4 flex items-center justify-center gap-2"
          data-testid="offline-banner"
        >
          <WifiOff size={20} />
          <span>{t("sync.offline")}</span>
        </div>
      )}

      {isOnline && pendingCount > 0 && (
        <div
          className="bg-blue-500 text-white text-center py-2 px-4 flex items-center justify-center gap-2"
          data-testid="sync-pending-banner"
        >
          {isSyncing ? (
            <>
              <RefreshCw size={20} className="animate-spin" />
              <span>{t("sync.syncing", { count: pendingCount })}</span>
            </>
          ) : (
            <span>{t("sync.pending", { count: pendingCount })}</span>
          )}
        </div>
      )}

      {lastSync !== null && (
        <div
          className="bg-gray-800 bg-opacity-80 text-gray-200 text-center py-1 px-4 flex items-center justify-center gap-2 text-xs"
          data-testid="last-sync-readout"
        >
          <span
            className={
              lastSyncAttemptOutcome === "error"
                ? "inline-block w-2 h-2 rounded-full bg-red-400"
                : "inline-block w-2 h-2 rounded-full bg-green-400"
            }
            data-testid="last-sync-outcome-dot"
            aria-hidden="true"
          />
          <span>
            {t("sync.lastSync", {
              time: lastSync.toLocaleTimeString(),
            })}
          </span>
        </div>
      )}
    </div>
  );
}
